import connect from "../../../shared/data-store/connect";
import {
	ACTION_RESET_PRICE_FILTER,
	ACTION_SET_PRICE_FILTER,
	store,
} from "./DataStore";
import { track } from "../../tracker/EventTracker";
import { getHistogramClass } from "./PriceFilterMaps";
import PriceFilter from "../PriceFilter";

customElements.define(
	"esc-hotel-list-price-filter",
	class extends connect(PriceFilter, store) {
		update(state, views) {
			this.updateAndRender(state, views);
		}

		onChange() {
			track(
				"Filter",
				"Preis Filter",
				`${
					this.histogram
						? this.value == this.max
							? this.histogram.length
							: getHistogramClass(
									this.histogram.length,
									this.value,
									this.min,
									this.max,
								)
						: "-"
				} | ${this.format(this.value)}${this.trackLabelSuffix}`,
			);
		}

		onChangeMax() {
			this.dispatchAction(ACTION_RESET_PRICE_FILTER);
		}

		onChangeValue(value) {
			this.dispatchAction(ACTION_SET_PRICE_FILTER, value);
		}

		get trackLabelSuffix() {
			return this.getAttribute("track-label-suffix") || "";
		}
	},
);
